module.exports = __webpack_public_path__ + "static/media/nafi_icon.f1b8c5be.svg";